import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

// Material UI
import {ArrowRightIcon} from "@mui/x-date-pickers";

// Components
import MobileItem from "components/WMS/Mobile/MobileItem";
import ThumbnailAndNotification from "components/WMS/Mobile/ThumbnailAndNotification";
import Badge from "components/Badge";

// Context
import {MissionContext} from "../context/MissionContext";

// Helpers
import {getTranslation} from "domain/helpers/translations";
import {WMSContext} from "../../context/WMSContext";
import {Grid} from "@mui/material";
import FormattedNumberWithCurrency
    from "../../../../components/formattedNumberWithCurrencies/formattedNumberWithCurrency";
import store from "../../../../store";
import {WmsItemsStatus} from "../../../../utils/WmsItemsStatus";

RetailerList.propTypes = {
    onClickRetailerLine: PropTypes.func,
    retailers: PropTypes.arrayOf(PropTypes.object).isRequired,
    filterValue: PropTypes.number.isRequired,
};

function RetailerList({onClickRetailerLine = (retailer) => {}, retailers, filterValue}) {
    const {
        getPickingTotal,
        getInTrolleyTotal,
        getCancelledTotal,
        getWmsItemsByRetailer,
    } = React.useContext(MissionContext);

    const {getItemTotalPrice} = useContext(WMSContext)

    function getBadgeColor(retailerItemsInTrolleyTotal, totalRetailerItems) {
        if (retailerItemsInTrolleyTotal > 0 && retailerItemsInTrolleyTotal < totalRetailerItems) {
            return 'warning';
        } else if (retailerItemsInTrolleyTotal === totalRetailerItems) {
            return 'online';
        }

        return 'info';
    }

    return (
        <Grid
            container
            sx={{
                fontSize: '16px',
                fontWeight: 600,
                overflow: 'auto',
                minHeight: 0,
            }}
            flex={1}
            alignContent={"baseline"}
        >
            {retailers?.map(retailer => {
                const items =  getWmsItemsByRetailer(retailer);
                const totalRetailerItems = items.length;

                let totalPrice = 0

                items.forEach((item) => {
                    totalPrice += getItemTotalPrice(item, filterValue === 1 ? [WmsItemsStatus.IN_TROLLEY] : undefined)
                })

                let totalFilteredItems = 0;

                const retailerItemsToPickTotal = getPickingTotal(items);
                const retailerItemsInTrolleyTotal = getInTrolleyTotal(items) + getCancelledTotal(items);

                if (filterValue === 0) {
                    totalFilteredItems = retailerItemsToPickTotal;
                } else if (filterValue === 1) {
                    totalFilteredItems = retailerItemsInTrolleyTotal;
                }

                if (totalFilteredItems === 0) {
                    return null;
                }

                return (
                    <MobileItem
                        onClick={() => onClickRetailerLine(retailer)}
                        key={retailer.id}
                    >
                        <MobileItem.LeftSide
                            title={retailer.name}
                            subtitle={(
                                <>
                                    {totalFilteredItems} <FormattedMessage id={"wms.myPickingMission.articles"}/>
                                </>
                            )}
                        >
                            <ThumbnailAndNotification
                                link={getTranslation(retailer)?.logo?.contentUrl || ""}
                                validated={retailerItemsInTrolleyTotal > 0 && retailerItemsInTrolleyTotal === totalRetailerItems}
                            />
                        </MobileItem.LeftSide>
                        <MobileItem.RightSide>
                            <div style={{display: 'flex'}}>
                                <Grid container sx={{marginRight: '8px'}} gap={'8px'} flexWrap={'nowrap'}>
                                    <Badge
                                        rounded={true}
                                        isBold={false}
                                        color={getBadgeColor(retailerItemsInTrolleyTotal, totalRetailerItems)}
                                        size={'large'}
                                    >
                                        {retailerItemsInTrolleyTotal}/{totalRetailerItems}
                                    </Badge>
                                    <Badge
                                        rounded
                                        color={"online"}
                                        isBold={false}
                                        size={"large"}
                                    >
                                        <FormattedNumberWithCurrency value={totalPrice} currency={store.getState().currentOrganization?.retrieved?.currency} />
                                    </Badge>
                                </Grid>
                                <ArrowRightIcon />
                            </div>
                        </MobileItem.RightSide>
                    </MobileItem>
                )
            })}
        </Grid>
    )
}

export default RetailerList;
